import { render, staticRenderFns } from "./OrdersProductTable.vue?vue&type=template&id=55e6ea5f&scoped=true"
import script from "./OrdersProductTable.vue?vue&type=script&lang=js"
export * from "./OrdersProductTable.vue?vue&type=script&lang=js"
import style0 from "./OrdersProductTable.vue?vue&type=style&index=0&id=55e6ea5f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e6ea5f",
  null
  
)

export default component.exports